import React from 'react';
import { useEffect, useState } from 'react';
import "../style/AgeConfirmation.css";
import { useTranslation } from 'react-i18next';
import { addEmailToSubscription } from '../controllers/MailController';
import LogoImage from '../images/ui/HeaderNewsLetter.webp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faX } from '@fortawesome/free-solid-svg-icons';

const shouldHideItem = (itemName) => {
    const displayAgainDate = localStorage.getItem(itemName);

    if (!displayAgainDate) {
        return false;
    }

    const now = new Date();
    const displayDate = new Date(parseInt(displayAgainDate, 10));

    return now < displayDate;
};

const setDisplayAgainDate = (itemName, delayInDays) => {
    const displayAgainDate = new Date();
    displayAgainDate.setDate(displayAgainDate.getDate() + delayInDays);
    localStorage.setItem(itemName, displayAgainDate.getTime().toString());
};

const NewsletterPopUp = () => {
    const { t } = useTranslation();

    const [email, setEmail] = React.useState("");
    const [messageNewsletter, setMessageNewsletter] = React.useState("");

    const [isConfirmed, setIsConfirmed] = useState(() => {
        return shouldHideItem('newsletterClosed');
    });

    // Once confirmed, allow scrolling again
    useEffect(() => {
        if (isConfirmed) {
        document.body.style.overflow = 'auto'; // Enable scrolling
        } else {
        document.body.style.overflow = 'hidden'; // Disable scrolling
        }
    }, [isConfirmed]);

    const resetNewsletterMessage = () => {
        setMessageNewsletter("");
    }

    // Handle the deny action
    const handleClose = () => {
        if (messageNewsletter === "success"){
            setDisplayAgainDate("newsletterClosed", 365);
        }
        else {
            setDisplayAgainDate("newsletterClosed", 14);
        }
        setIsConfirmed(true);
    };

    const handleSubscribe = async () => {
        if (!email) return;
        try {
            const result = await addEmailToSubscription(email);
            if (!result)
                setMessageNewsletter("failed")
            else 
                setMessageNewsletter("success")
            setEmail("");
        } catch (error) {
            setMessageNewsletter("error");
        }
    };

    // If confirmed, return nothing
    if (isConfirmed) return null;
        return (
        <div className={`centered-overlay`}>
                <div className="age-confirmation-overlay">
                    <div className="age-confirmation-modal newsletter-modal">
                        <img 
                            src={LogoImage} 
                            alt="Newsletter header" 
                            className="newsletter-header-image" 
                        />
                        <button
                            className="newsletter-close-button"
                            onClick={handleClose}
                            aria-label={t('newsletterPopUp.close') || 'Close'}
                        >
                            <FontAwesomeIcon icon={faX} />
                        </button>
                        <p className="smaller-title-modal smaller-title-pop-up">{t("newsletterPopUp.title")}</p>
                        <h3>{t("newsletterPopUp.funText")}</h3>
                        <label>{t("newsletterPopUp.normalText")}</label>
                        <div className="search-newsletter-popup">
                            {messageNewsletter ? 
                                <div className="mailing-response-container">
                                    {messageNewsletter && 
                                        <p className="newsletter-message">
                                            {messageNewsletter === "success"
                                                ? t('footer.newsletterConfirm')
                                                : messageNewsletter === "failed"
                                                ? t('footer.newsletterFailed')
                                                : messageNewsletter === "error"
                                                ? t('footer.newsletterError')
                                                : messageNewsletter}
                                        </p>
                                    }
                                    {messageNewsletter !== "success" &&
                                        <FontAwesomeIcon
                                            className="footer-close-button"
                                            icon={faX}
                                            onClick={resetNewsletterMessage}
                                        />
                                    }
                                </div> 
                                :
                                <div className="search-container search-container-popup">
                                    <input
                                        className="footer-email input-pop-up"
                                        type="text"
                                        placeholder={t('footer.emailPlaceholder')}
                                        value={email}
                                        onChange={e => setEmail(e.target.value)}
                                    />
                                    <button className="footer-search-button" onClick={handleSubscribe}>
                                        {t('footer.subscribe')}
                                    </button>
                                </div> 
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    };

export default NewsletterPopUp;
